import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import UIStrings from '@/Utils/UIStrings';
import { useCreateRecruitmentContext } from '../../../../../../Create/Contexts/CreateRecruitmentContext';
import mapLocaleCodeToLanguageName from '@/Utils/mapLocaleCodeToLanguageName';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/Components/shadcn/select';
import { TypographyH3 } from '@/Components/shadcn';
import { TestSelectionFormValues } from '../../../../SelectTestsStep';

export const testLanguageField = 'testLanguageField';

type LanguageOption = { id: string; name: string };

function TestLanguage(): React.JSX.Element {
    const { control } = useFormContext<TestSelectionFormValues>();
    const { locales } = useCreateRecruitmentContext();

    const options: LanguageOption[] = useMemo(() => {
        const anyLocale: LanguageOption = { id: 'applicant', name: UIStrings.ApplicantsSelectLanguage };
        return [
            anyLocale,
            ...locales.map((locale) => ({
                id: locale,
                name: mapLocaleCodeToLanguageName(locale),
            })),
        ];
    }, [locales]);

    return (
        <div className="border-border bg-alicia flex w-full flex-col items-center gap-3 rounded-lg border p-4">
            <TypographyH3 className="text-foreground text-center">{UIStrings.TestLanguage}</TypographyH3>
            <Controller
                name={testLanguageField}
                control={control}
                render={({ field }) => (
                    <Select value={field.value} onValueChange={field.onChange}>
                        <SelectTrigger
                            id={testLanguageField}
                            data-cy={testLanguageField}
                            aria-label={UIStrings.TestLanguage}
                            className="w-64"
                        >
                            <SelectValue placeholder={UIStrings.ApplicantsSelectLanguage} />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectGroup>
                                {options.map((option) => (
                                    <SelectItem key={option.id} value={option.id}>
                                        {option.name}
                                    </SelectItem>
                                ))}
                            </SelectGroup>
                        </SelectContent>
                    </Select>
                )}
            />
        </div>
    );
}

export default TestLanguage;
